import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Attendance } from '../../../class/attendance';
import { CitationService } from '../../../service/citation/citation.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { RequisitionService } from '../../../service/requisition/requisition.service';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { config } from '../../../../../../environments/config';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { CandidateService } from '../../../service/candidate/candidate.service';
import { Candidate } from '../../../class/candidate';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../theme/functions/calendarES';
import { element } from 'protractor';
import { Requisition } from '../../../class/requisition';

@Component({
  selector: 'app-exclusion-candidate-form',
  templateUrl: './exclusion-candidate-form.component.html',
  styleUrls: ['./exclusion-candidate-form.component.scss']
})
export class ExclusionCandidateFormComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Input() name: String;
  
  exclusionCandidateOptions: { label: string; value: string; }[];
  terminationOptions: { label: string; value: string; }[];
  nameForm: string = '';

  constructor(private formBuilder: FormBuilder,
              public translate: TranslateService,
              ) 
  {
    // this.nameForm = this.name.toString(); //'exclusion_referencing';//this.name.toString(); 
    this.exclusionCandidateOptions = [
      {label: 'Preguntar', value: '2'},
      {label: 'No volver a contratar', value: '3'},
    ];
    this.terminationOptions = [
        {label: 'Inconsistencias en documentos', value: '1'},
        {label: 'Terminación con justa causa', value: '2'},
        {label: 'Diagnostico médico no compatible con actividad a ejercer', value: '3'},
    ];
  }

  ngOnInit() {
    this.nameForm = this.name.toString(); //'exclusion_referencing';//this.name.toString(); 
    const innerFormGroup = this.formBuilder.group({
      // innerControl: ['', Validators.required],
      exclusion_id: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      termination_id: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      // process: [this.nameForm]
    });
    this.parentForm.addControl(this.nameForm, innerFormGroup);
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/candidate-comments/exclusion-candidate-form/exclusion-candidate-form.component.ts